import { useQuery } from '@tanstack/react-query';

import { MIN_SEARCH_LENGTH } from '@utils/utils';
import { VehicleOfficeSearchViewModel } from '@api/index';

import { fetchLocationsItems } from '../utils';
import { getVehicleName } from '../../utils';

interface ILocationSearch {
  location?: string;
  onSuccess?: ((data: VehicleOfficeSearchViewModel[]) => void) | undefined;
  onError?: ((err: unknown) => void) | undefined;
  enabled?: boolean;
  selectedLocationData?: VehicleOfficeSearchViewModel;
}

export function useLocationSearchGet({
  location = '',
  onSuccess,
  onError,
  selectedLocationData,
}: ILocationSearch) {
  return useQuery(
    ['vehicle-search', location],
    () => fetchLocationsItems(location),
    {
      onSuccess,
      onError,
      enabled:
        location?.length > MIN_SEARCH_LENGTH &&
        Boolean(location !== getVehicleName(selectedLocationData || null)),
    }
  );
}
